import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import AsyncSelectField from "../../Shared/AsyncSelect"
import { gender_list, status_list } from "../../Shared/List"
import FileField from "../../Shared/FileField"

const UpdateEmployeeForm = () => {
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [genderOption, setGenderOptions] = useState([{id: "", name: '-- Please choose gender --', key: 'NAN'}])
    const [categoryOptions, setCategoryOptions] = useState([{id: "", name: '-- Please choose occupation --', key: 'NAN'}])
  const [statusOption, setStatusOption] = useState([{id: "", name: '-- Please choose status --', key: 'NAN'}])

  const [formData, setFormData] = useState({
    full_name: "",
    contact_number: "61",
    gender: "",
    category_id: "",
    salary: 0,
    status: "",
    responsible_name: "",
    responsible_contact: "",
    public_id: "",
    contract: "",
    picture: "",
  })
  const {full_name, contact_number, gender, status, category_id, salary, responsible_name, responsible_contact, public_id, picture, contract} = formData

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {

    if (location.state){
        const {employee} = location.state
        setFormData((prev) => ({
            ...prev,
            full_name: employee.full_name,
            contact_number: employee.contact_number,
            category_id: employee.category_id,
            gender: gender_list.find(item => item.name === employee.gender).id,
            status: status_list.find(item => item.name === employee.status).id,
            salary: employee.salary,
            responsible_contact: employee.responsible_contact,
            responsible_name: employee.responsible_name,
            public_id: employee.public_id,
        }))
    }
  }, [location])

  const loadOptions = async (url, query, setOptions) => {
        const genders = genderOption
        const statuses = statusOption

        gender_list.map(gender => (
            genders.push({
                id: gender.id,
                name: gender.name,
                key: gender.key
            })
        ))

        status_list.map(status => (
            statuses.push({
                id: status.id,
                name: status.name,
                key: status.key
            })
        ))
        setGenderOptions(genders)
        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };
  

  const onChange = (e) => {
    const { name, files, value } = e.target;
    setFormData((prev) => {
    const isFile = name === "contract" || name === "picture";
    const newValue = isFile ? files[0] : value;
    return {
        ...prev,
        [name]: newValue,
    };
    });
  }

  const onSubmit = (e) => {
      e.preventDefault()

      const gender = gender_list[formData.gender - 1]?.name || "Male"
      const status = status_list[formData.status - 1]?.name || "Active"
      const payload = {category_id, full_name, contact_number, gender, status,     responsible_name, responsible_contact, salary, picture, contract}
    
      updateEmployee(payload)
  }
  
  // update employee
  const updateEmployee = async (payload) => {
      setIsLoading(true);
      
      const dataToSend = new FormData();
      dataToSend.append("full_name", payload.full_name);;
      dataToSend.append("contact_number", payload.contact_number);
      dataToSend.append("gender", payload.gender);
      dataToSend.append("category_id", payload.category_id);
      dataToSend.append("status", payload.status);
      dataToSend.append("salary", payload.salary);
      dataToSend.append("responsible_name", payload.responsible_name || "");
      dataToSend.append("responsible_contact", payload.responsible_contact || "");
      dataToSend.append("picture", payload.picture);
      dataToSend.append("contract", payload.contract);
      
      try {
          const response = await Server.put(`/employees/${public_id}`, dataToSend, {headers: {'Content-Type': 'multipart/form-data'}})
            navigate('/employees')
            setIsLoading(false)
            toast.success(response?.data?.detail || "Successfully updated")
      } catch (error) {
          setIsLoading(false)
          if(error.response.status === 401){
              navigate('/login')
          }else if (error.response.status === 422) {
            setErrors({})
            error.response?.data?.detail.map((err) => (
                setErrors((prevState) => ({
                    ...prevState,
                    [err.loc[1]]: err.msg
                }))
            ))
        }else if (error.response.status === 403){
            toast.error(error.response.data.detail);
            navigate('/');
        }else {
            setErrors(error.response.data?.detail)
          }
      }
  }

  if(isLoading){
      return <Spinner/>
  }

return (
  <>
    <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update Employee Form</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Full Name"
                                name="full_name"
                                type="text"
                                label="Name"
                                value={full_name}
                                onChange={onChange}
                                error={errors.full_name}
                            />
                        </div>

                        <div className="col-md-3">
                            <InputField
                                placeholder="Employee Contact"
                                name="contact_number"
                                type="text"
                                label="Contact"
                                value={contact_number}
                                onChange={onChange}
                                error={errors.contact_number}
                            />
                        </div>

                        <div className="col-md-3">
                            <SelectField
                                name="gender"
                                label="Gender"
                                value={gender}
                                options={genderOption}
                                onChange={onChange}
                                error={errors.gender}
                            />
                        </div>

                        <div className="col-md-3">
                            <InputField
                                placeholder="Salary"
                                name="salary"
                                type="number"
                                label="Salary"
                                value={salary}
                                onChange={onChange}
                                error={errors.salary}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <SelectField
                                name="status"
                                label="Status"
                                value={status}
                                options={statusOption}
                                onChange={onChange}
                                error={errors.status}
                            />
                        </div>
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="category_id"
                                label="Occupation"
                                value={category_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('employee-categories', query, setCategoryOptions)}
                                options={categoryOptions}
                                placeholder="Start typing to search..."
                                error={errors.category_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Responsible Person Name"
                                name="responsible_name"
                                type="text"
                                label="Responsible Name"
                                value={responsible_name}
                                onChange={onChange}
                                error={errors.responsible_name}
                            />
                        </div>

                        <div className="col-md-3">
                            <InputField
                                placeholder="Responsible Person Contact"
                                name="responsible_contact"
                                type="text"
                                label="Responsible Contact"
                                value={responsible_contact}
                                onChange={onChange}
                                error={errors.responsible_contact}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FileField
                                name="contract"
                                type="file"
                                label="Contract(Optional)"
                                value={contract}
                                onChange={onChange}
                                error={errors.contract}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileField
                                name="picture"
                                type="file"
                                label="Picture(Optional)"
                                value={picture}
                                onChange={onChange}
                                error={errors.picture}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update Employee" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
  </>
)
}

export default UpdateEmployeeForm
